module.exports = __webpack_public_path__ + "img/15.d94e418c.png";